import client from '../helpers/HttpClient';
import handleError from '../helpers/error';

class termService {
  async fetch(params) {
    try {
      const result = await client.get('term/index', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async get(id) {
    try {
      const result = await client.get(`term/view`, { params: { id } });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async save(obj) {
    try {
      const result = await client.post(`term/save`, obj);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async remove(id) {
    try {
      const result = await client.post(`term/delete/${id}`);
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }

  async fetchAcceptances(params) {
    try {
      const result = await client.get('term/acceptances', { params });
      return result?.data;
    } catch (error) {
      return Promise.reject(handleError(error));
    }
  }
}

export default new termService();
